import { useState } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useMutation } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { remove } from "../services/api";
import { useTranslation } from "react-i18next";

export default function Remove({ open, close, category, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)

  const mutation = useMutation(remove, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleRemove = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: { category }})
  }

  const handleClose = () => { close() }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="error" onClick={() => handleRemove()}>{t("button_text_delete")}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('builder_subcategories_dialog_title_delete')} actions={<Actions />}>
      <Typography variant="body1" component="p">
        {t("builder_subcategories_dialog_confirm_delete_text", { name: instance.name })}
      </Typography>
    </FlexibleWidthDialog>
  </>)
}